import BaseCreatePage from '../../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import { Portlet, PortletBody, PortletHeader } from "../../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as forecastBatchCrud from '../../../../../crud/forecastBatch.crud';
import * as forecastCrud from '../../../../../crud/forecast.crud';
import * as projectOrderCrud from '../../../../../crud/projectOrder.crud';
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { withCreatePageProps } from '../../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../../shared/common';
import { actionCodes } from "../../../../../shared/lookup";
import PortletSpinner from '../../../../../partials/layout/PortletSpinner';

const rightAlignedNumberBox = {
  editorOptions: {
    elementAttr: { class: 'text-right' }
  }
};

class FirstWizardPage extends BaseCreatePage {
    constructor(props) {
        super(props);

        this.batchForecastForPackagedContractEnabled = props.contract.ispackaged;

        if (this.batchForecastForPackagedContractEnabled) {
            this.projectOrderNotificationName = (this.props.workflowsQA['72'] || {}).notificationName;
        }

        this.state = {
            showAlert: true,
            projectOrders: null,
            lastForecastAmounts: null
        };
    }

    componentDidMount() {
        this.fetchProjectOrders();
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);
            
            if (!responseObj || responseObj.length === 0) {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.NO_PROJECTORDER_DEF' }), { variant: 'error', });
                return;
            }

            const projectOrders = responseObj.map(PO => ({
                value: PO.projectorderid,
                reference: PO.referenceid,
                display: `${PO.referenceid} - ${PO.subject}`,
                completed: PO.pmcompletiondate !== null
            }));
            this.setState({ projectOrders }, () => this.fetchLastForecastAmountsForProjectOrders());
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load project orders', { variant: 'error', });
        }
    }

    fetchLastForecastAmountsForProjectOrders = async () => {
        try {
            const contractId = this.props.contract.contractid;
            const projectOrderIds = this.state.projectOrders.map(x => x.value);

            const { data } = await forecastCrud.getLastForecastAmounts(
                contractId,
                projectOrderIds
            );

            this.setState({ lastForecastAmounts: data });
        } catch (err) {
            console.log(err);
        }
    };

    calculateRowTotal = (dataFieldBase, obj) => {
        const columnCount = this.state.projectOrders.length;
            
        let total = 0;
        for (let i = 1; i <= columnCount; i++) {
            const fieldKey = `${dataFieldBase}${i}`;

            //If fieldKey is undefined, set value and break the loop
            if (fieldKey === 'undefined1') {
                total = this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' });
                break; // Exit the loop
            }

            // if (this.batchPaymentForPackagedContractEnabled && fieldKey.includes('lastpaymentcertificateamount') && !obj[fieldKey]) {
            //     total += this.getInitialAmountForIndex(i);
            // } else {
            //     total += (obj[fieldKey] || 0);
            // }

            total += (obj[fieldKey] || 0);
        }
        
        return total;
    };

    duplicateFieldWithCount(field, count, calculationFunction) {
        const duplicatedFields = [];

        for (let i = 0; i < count; i++) {
            const colIndex = i + 1;

            const duplicatedField = {
                label: `${field.label} ${colIndex}`,
                dataField: `${field.dataField}${colIndex}`,
                required: field.required,
                editorType: field.editorType,
                horizontalfield: true,
                editorOptions: { ...field.editorOptions }
            };

            if (i === 0 && field.resource) {
                duplicatedField.resource = field.resource;
            }

            duplicatedField.currency = this.props.contract.currency;

            if (field.value) {
                duplicatedField.value = field.value.bind(null, colIndex);
            }

            if (this.state.lastForecastAmounts[i]?.ispmcertifiedcomplete &&
                field.editorType === 'dxNumberBox' //this check is to make sure that the value function is only assigned for the cost forecast fields, and not to override project order's value function which is to format the display of project order reference
            ) {
                duplicatedField.editorOptions.readOnly = true;
                duplicatedField.value = this.calculateLastForecastAmount.bind(this, colIndex);
            }

            duplicatedFields.push(duplicatedField);
        }

        return duplicatedFields;
    }

    generateFieldsWithDuplicates(fields) {
        const updatedFields = [];

        fields.forEach(field => {
            if (field.columnCount) {
                // 1. Generate the standard duplicated fields (Project Order 1, 2, etc.)
                const duplicatedFields = this.duplicateFieldWithCount(field, field.columnCount, field.value);
                
                // 2. Add the Total column only if batch payment for packaged contract is enabled
                if (this.batchForecastForPackagedContractEnabled) {
                    // Create the Total field definition
                    const totalField = {
                        label: this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }), 
                        dataField: `${field.dataField}Total`,
                        editorType: field.hasOwnProperty('dataField') ? 'dxNumberBox' : 'dxTextBox', //For total label, we use TextBox
                        horizontalfield: true,
                        readOnly: true,
                        value: this.calculateRowTotal.bind(this, field.dataField),
                        editorOptions: {
                             currency: this.props.contract.currency, 
                             readOnly: true,
                             elementAttr: { class: 'text-right' }
                        }
                    };
                    duplicatedFields.push(totalField);
                }

                const transformedField = {
                    horizontalrow: true,
                    ...(field.label && { label: field.label }),
                    ...(field.resource && { resource: field.resource }),
                    // The horizontalfields array now contains the base columns and, optionally, the Total column
                    horizontalfields: duplicatedFields.map(duplicatedField => ({ ...duplicatedField }))
                };
                updatedFields.push(transformedField);
            } else {
                updatedFields.push(field);
            }
        });

        return updatedFields;
    }

    submitHandler = (forecastBatch) => {
        forecastBatch.companyid = this.props.contract.companyid;
        forecastBatch.contractid = this.props.contract.contractid;
        forecastBatch.projectid = this.props.contract.projectid;
        forecastBatch.forecastdatedisplay = moment(forecastBatch.forecastdate).format('DD/MM/YYYY');

        forecastBatch.subject = forecastBatch.subject;
        forecastBatch.description = forecastBatch.description;
        forecastBatch.replycomment = forecastBatch.replycomment;
        forecastBatch.type = this.props.workflowItem.config.currentModelType;
        forecastBatch.status = 'Not Communicated';
        forecastBatch.createdate = new Date();
        forecastBatch.createdatedisplay = moment().format('DD/MM/YYYY');

        delete forecastBatch.newcostforecastTotal;
        // delete forecastBatch.targetTotal;
        // delete forecastBatch.actualTotal;
        // delete forecastBatch.varianceTotal;

        const newcostforecasts = Object.keys(forecastBatch)
            .filter(key => key.startsWith('newcostforecast'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('newcostforecast', ''));
                const numB = parseInt(b.replace('newcostforecast', ''));
                return numA - numB;
            })
            .map(key => forecastBatch[key]);

        forecastBatch.newcostforecasts = newcostforecasts;

        // const targets = Object.keys(forecastBatch)
        //     .filter(key => key.startsWith('target'))
        //     .sort((a, b) => {
        //         const numA = parseInt(a.replace('target', ''));
        //         const numB = parseInt(b.replace('target', ''));
        //         return numA - numB;
        //     })
        //     .map(key => forecastBatch[key]);

        // forecastBatch.targets = targets;

        // const actuals = Object.keys(forecastBatch)
        //     .filter(key => key.startsWith('actual'))
        //     .sort((a, b) => {
        //         const numA = parseInt(a.replace('actual', ''));
        //         const numB = parseInt(b.replace('actual', ''));
        //         return numA - numB;
        //     })
        //     .map(key => forecastBatch[key]);

        // forecastBatch.actuals = actuals;

        // const variances = Object.keys(forecastBatch)
        //     .filter(key => key.startsWith('variance'))
        //     .sort((a, b) => {
        //         const numA = parseInt(a.replace('variance', ''));
        //         const numB = parseInt(b.replace('variance', ''));
        //         return numA - numB;
        //     })
        //     .map(key => forecastBatch[key]);

        // forecastBatch.variances = variances;

        //this.props.onHandleForecastBatchMultipleProjectOrders(forecastBatch);

        forecastBatch.currencies = this.state.projectOrders.map(() => this.props.contract.currency); //creates a new array with the exact same length of project orders, filled only with contract.currency

        forecastBatch.projectorders = this.state.projectOrders.map(x => x.value);

        forecastBatch.actioncode = actionCodes.CREATE;
        this.appendRelationship(forecastBatch);
        Common.PropertyConversionsBeforeNoticeSaveRequest(forecastBatch, this.customFields, this.props.contractUsers);
        forecastBatchCrud.batchCreateDrafts(forecastBatch)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdItems = response.data;

                    const forecastBatchId = createdItems?.[0]?.forecastbatchid;

                    this.props.onHandleForecastBatchMultipleProjectOrders(forecastBatchId);
                    this.props.onValueChanged(false, null);
                    //this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    formatProjectOrder = (index) => {
        const po = this.state.projectOrders[index - 1]?.display;
        return po;
    }

    onValueChanged = async (e, val) => {
        //this.props.onValueChanged(true, 'first');

        this.setState({
            [e]: val
        });

        // Call base handler if it exists
        // if (super.onValueChanged) {
        //     super.onValueChanged(e);
        // }
    }

    // calculateVariance = (index, obj) => {
    //     //const prc1 = obj.target ? obj.target : 0;
    //     const prc1 = obj[`target${index}`] || 0;
    //     //const prc2 = obj.newcarbonforecast ? obj.newcarbonforecast : 0;
    //     const prc2 = obj[`newcarbonforecast${index}`] || 0;
    //     return prc2 - prc1;
    // }

    calculateLastForecastAmount = (index, obj) => {
        return this.state.lastForecastAmounts[index - 1]?.ispmcertifiedcomplete ? this.state.lastForecastAmounts[index - 1]?.amount : 0;

        // const lastAmountData = this.state.lastForecastAmounts[index - 1];
    
        // if (lastAmountData?.ispmcertifiedcomplete) {
        //     return lastAmountData.amount || 0;
        // }
        
        // return obj[`newcostforecast${index}`] || 0;
    };

    render() {
        if (!this.state.projectOrders || !this.state.lastForecastAmounts) {
            return <PortletSpinner />;
        }

        const { fields } = this.props.workflowItem;

        const minAmount = 1;//!this.state.minValueAccepted && this.state.minValueDecided ? 1 : 0;

        const columnCount = this.state.projectOrders.length;

        // const createFormConfig = {
        //     model: 'ForecastBatch',
        //     title: this.props.workflowItem.notificationName,
        //     cancelButton: false,
        //     submitButtonText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_NEXT' }),
        //     onSubmit: this.submitHandler,
        //     fields: [
        //         { label: fields.ForecastDate.label, dataField: 'forecastdate', editorType: 'dxDateBox', validation: { type: 'required' } },
        //         { label: fields.Summary.label, dataField: 'summary', editorType: 'dxTextArea', validation: { type: 'required' } }
        //     ]
        // };

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Subject.label, dataField: 'subject', editorOptions: { defaultValue: this.createDefaultSubject } },
                { label: fields.ForecastDate.label, dataField: 'forecastdate', editorType: 'dxDateBox', required: true, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" })} },
                { label: fields.Details.label, dataField: 'description', editorType: 'dxHtmlEditor' }
            ]
        };

        if (fields.Type.visible) {
            createFormConfig.fields.splice(2, 0, ({ label: fields.Type.label, dataField: 'replycomment', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses,  valueExpr: 'display', displayExpr: 'display' } }));
        }

        // Add the 'Total' label to the end of the Project Order references
        const horizontalLabels = [
            ...this.state.projectOrders.map(x => x.reference),
            this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }) //Added Total Label
        ];

        createFormConfig.fields.push(
            { horizontallabels: horizontalLabels },
            { label: this.projectOrderNotificationName, value: this.formatProjectOrder, editorType: 'dxTextArea', columnCount: columnCount, editorOptions: { autoResizeEnabled: true }/*, editorOptions: { itemTemplate : this.itemTemplate }*/ },
        );

        createFormConfig.fields.push({ label: fields.CostForecast.label, dataField: 'newcostforecast', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox, validation: { type: 'range', min: minAmount, warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.MINIMUM_VALUE" }) + " " + Common.FormatCurrencyNum(minAmount, this.props.contract.currency)} });

        // if (fields.Target?.visible) {
        //     createFormConfig.fields.push({ label: fields.Target.label, dataField: 'target', required: true, editorType: 'dxNumberBox', columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, defaultValue: this.state.target, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }
        // // if (fields.Forecast?.visible) {
        // //     createFormConfig.fields.push({ label: fields.Forecast.label, dataField: 'newcarbonforecast', editorType: 'dxNumberBox', editorOptions: { defaultValue: this.state.carbonForecast, min: 0, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // // }
        // if (fields.Actual?.visible) {
        //     createFormConfig.fields.push({ label: fields.Actual.label, dataField: 'actual', required: true, editorType: 'dxNumberBox', columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }
        // if (fields.Variance?.visible) {
        //     createFormConfig.fields.push({ label: fields.Variance.label, dataField: 'variance', required: true, editorType: 'dxNumberBox', value: this.calculateVariance, columnCount: columnCount, editorOptions: { ...rightAlignedNumberBox.editorOptions, defaultValue: this.state.variance, format: '#,##0.00 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES_CO2' }) } })
        // }

        // if (this.batchForecastForPackagedContractEnabled) {
        //     // Add project order selection
        //     const projectOrderFields = this.state.projectOrders.map((po, index) => {
        //         const lastAmount = this.state.lastForecastAmounts?.find(lfa => lfa.projectorderid === po.value)?.amount || 0;
        //         return {
        //             label: `${po.display} - Forecast Amount`,
        //             dataField: `projectorder${index + 1}`,
        //             editorType: 'dxNumberBox',
        //             editorOptions: {
        //                 format: '#,##0.00',
        //                 min: 0,
        //                 disabled: po.completed // Disable if completed
        //             },
        //             validation: { type: 'required' },
        //             defaultValue: po.completed ? lastAmount : 0
        //         };
        //     });

        //     createFormConfig.fields.push(...projectOrderFields);
        // }

        const updatedFields = this.generateFieldsWithDuplicates(createFormConfig.fields);

        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1001, height: 'auto' }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                        </Alert>
                    )}
                    {this.props.resources.WarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.WarningBanner}
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        //config={createFormConfig}
                        config={{ ...createFormConfig, fields: updatedFields }}
                        valueChangeHandler={this.onValueChanged}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractUsers: store.contract.users
});

export default injectIntl(withCreatePageProps(connect(mapStateToProps)(FirstWizardPage)));